type UniformScheduleAccess = {
  isViewOnly?: boolean;
  statusStr?: string;
};

export function isScheduleViewOnly(schedule?: UniformScheduleAccess | null) {
  return schedule?.isViewOnly === true;
}

export function canStartUniformSurvey(
  schedule: UniformScheduleAccess | null | undefined,
  allowSubmit?: boolean
) {
  return (
    schedule?.statusStr === "Active" &&
    allowSubmit === true &&
    !isScheduleViewOnly(schedule)
  );
}

export function canViewUniformSurvey(
  schedule: UniformScheduleAccess | null | undefined
) {
  return schedule?.statusStr === "Active" || isScheduleViewOnly(schedule);
}

export function canEnterUniformSubmission(
  schedule: UniformScheduleAccess | null | undefined
) {
  return !isScheduleViewOnly(schedule);
}
